<div class="u-shadow-mini pos-relative">
  <app-loader [showLoader]=showLoad></app-loader>
  <div class="c-portlet_box_specs">
    <div *ngIf="!hasData">
      <div class="creative-title primary-color">
        <h5>{{sectiontitle}}</h5>
      </div>
      <div class="parameters-div" style="padding: 15px 20px">
        No data found
      </div>
    </div>

    <div *ngIf="hasData">
      <div class="creative-title primary-color">
        <label [title]="currentCreativeData?.creativeName">
          <b>{{ sectiontitle }}</b>
        </label>
      </div>
      <div class="carousel-area">
        <div class="creative-performance-stats">

          <div class="creative-carousel" *ngIf="screenShotsData?.length > 0">

            <span (click)="slideLeft()" class="u-cursor-pointer">
              <img src="../../../../../assets/creative-assets/left-arrow.svg" class="left-arrow">
            </span>
            <ngx-carousel-3d [slides]="screenShotsData" [slideClass]="'screenshots'" [options]="options" class="col-12" #screencarousel>
              <div *ngFor="let slide of screenShotsData; let i = index">
                <div class="carouselImg" (click)="slideClicked(i)">
                  <div class="slideMask"></div>
                  <img class="slide-img" (click)="previewScreenshot(slide?.imageURL)" src="{{ slide.imageURL }}" width="300" height="250" alt="" />
                </div>
              </div>
            </ngx-carousel-3d>
            <ul class="carousel-points-container-r5 myPoint" *ngIf="graphData">
              <li [ngClass]="{'highlight-light': i===selectedIndex}" *ngFor="let j of carousel.$slides; let i = index">
              </li>
            </ul>
            <span (click)="slideRight()" class="u-cursor-pointer">
              <img src="../../../../../assets/creative-assets/right-arrow.svg" class="right-arrow">
            </span>
            <div class="text-align-center">
              <h4 class="creative-name r5-screen-shots" (click)="previewScreenshot(currentScreenshotData?.imageURL)">
                  {{ currentScreenshotData?.domainName }}
                  <br>
                  {{ currentScreenshotData?.date }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>